import React from 'react';
import AboutHotel from '../../containers/AboutHotel';
import Container from '../Container';
import Paper from '../Paper';
import EmptyAboutHotel from '../HotelInfo/EmptyAboutHotel';

interface AboutHotelMobileProps {
  hasRating: boolean;
  isLastReview: boolean;
  hasFacts: boolean;
  hasAboutHotel: boolean;
}

const AboutHotelMobile = ({
  hasRating,
  isLastReview,
  hasFacts,
  hasAboutHotel,
}: AboutHotelMobileProps) => (
  <>
    {/* Об отеле */}
    {hasAboutHotel && (
      <Container isMobile>
        <Paper padding={10}>
          <AboutHotel isMobile />
        </Paper>
      </Container>
    )}
    {!hasAboutHotel && !hasFacts && !hasRating && !isLastReview && (
      <EmptyAboutHotel isMobile />
    )}
  </>
);

export default React.memo(AboutHotelMobile);
